import esTranslation from "./es.json";
import enTranslation from "./en.json";

const translations = {
	es: esTranslation,
	en: enTranslation,
};

export default translations;
